<template>
  <div
    class="presentation-audio"
    :class="{
      show: isShowPrompt && !hasConfirm
    }"
  >
    <div class="text-confirm">
      Cho phép phát nhạc nền trên thiết bị này
    </div>
    <div class="actions">
      <button class="btn-action-deny" @click="handleAcceptAudioPlayable(false)">
        Từ chối
      </button>
      <button class="btn-action-accept" @click="handleAcceptAudioPlayable(true)">
        Đồng ý
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      audio: null,
      canPlayBgMusicOnThisDevice: false,
      isShowPrompt: false,
      hasConfirm: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    hasSlideAudio() {
      return this.slide && (this.slide.audioName || this.slide.audioLink)
    },
  },
  watch: {
    hasSlideAudio: {
      handler(value) {
        if (!this.audio) return

        if (value) {
          this.audio.pause()
          this.audio.currentTime = 0
        }

        if (!value && this.canPlayBgMusicOnThisDevice) {
          this.audio.play()
        }
      },
      immediate: true,
    },
    canPlayBgMusicOnThisDevice: {
      handler(value) {
        if (value) {
          this.audio.play()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initShowPrompt()
    this.initAudio()
  },
  methods: {
    initAudio() {
      const { audioLink } = this.presentation

      if (audioLink && audioLink.url) {
        this.audio = new Audio(audioLink.url)
        this.audio.loop = true
      }
    },
    initShowPrompt() {
      if (sessionStorage.getItem('canPlayBgMusicOnThisDevice')) {
        this.canPlayBgMusicOnThisDevice = JSON.parse(sessionStorage.getItem('canPlayBgMusicOnThisDevice'))
        this.hasConfirm = true

        return
      }

      setTimeout(() => {
        this.isShowPrompt = true

        setTimeout(() => {
          this.isShowPrompt = false
        }, 10000)
      }, 3000)
    },
    handleAcceptAudioPlayable(accepted) {
      this.canPlayBgMusicOnThisDevice = accepted
      this.hasConfirm = true

      sessionStorage.setItem('canPlayBgMusicOnThisDevice', accepted)
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-audio {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  text-align: center;
  color: #313131;
  background-color: #fff;
  padding: 16px 24px;
  transition: 0.7s all ease;
  box-shadow: 0 4px 5px 0px rgba(0,0,0,0.2);
  z-index: 9999; // always on top

  &.show {
    top: 0;
  }

  .actions {
    display: flex;
    justify-content: center;
    margin-top: 16px;

    button {
      padding: 6px 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
    }

    .btn-action-deny {
      margin-right: 12px;
      background-color: #DFE3E9;
      color: #313131;
    }

    .btn-action-accept {
      background-color: #257ADC;
      color: #fff;
    }
  }
}
</style>
